import {func} from 'prop-types';
import Header from '../../../shared/Header';
import Stack from '../../../shared/layouts/Stack';
import Notification from '../components/Notification';
import { useTranslation } from 'react-i18next';

const ToolsWidget = () => {
  const { t } = useTranslation();

  const tools = [{
    id: 'maxmortgage',
    type: 'max_mortgage',
    title: 'Maximale hypotheek',
    message: 'Bekijk hoeveel je maximaal verantwoord kan lenen.',
  }];

  return (
    <Stack space="2xl" bg="white">
      <Header
        title={t('Handige tools')}
        variant="page"
      />
      <Stack space="m">
        {tools.map((tool) => (
          <Notification key={tool.id} {...tool} />
        ))}
      </Stack>
    </Stack>
  );
};

ToolsWidget.propTypes = {
  setIsLoading: func,
};

ToolsWidget.defaultProps = {
  setIsLoading: () => {},
};

export default ToolsWidget;
